import React from 'react';
import { Link } from 'react-router-dom';

const DMCAPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/" className="text-orange-500 hover:text-orange-600 mb-8 inline-block">
          ← Back to Home
        </Link>
        
        <h1 className="text-4xl font-bold mb-4">DMCA Copyright Policy</h1>
        <p className="text-gray-400 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>
        
        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Copyright Infringement Notification</h2>
            <p className="mb-4">
              Trap Comix respects the intellectual property rights of others and expects users to do the same. 
              In accordance with the Digital Millennium Copyright Act ("DMCA"), we will respond promptly to 
              notices of alleged copyright infringement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Filing a DMCA Notice</h2>
            <p className="mb-3">
              If you believe that content on Trap Comix infringes your copyright, please send a written notice 
              that includes the following:
            </p>
            <ol className="list-decimal list-inside space-y-3 ml-4">
              <li>
                <strong>Identification of the copyrighted work</strong> you claim has been infringed, or if multiple works, 
                a representative list
              </li>
              <li>
                <strong>Identification of the infringing material</strong> and information reasonably sufficient to locate it 
                (e.g., URL, series title, episode number)
              </li>
              <li>
                <strong>Your contact information:</strong> name, address, telephone number, and email address
              </li>
              <li>
                <strong>A statement</strong> that you have a good faith belief that use of the material is not authorized by 
                the copyright owner, its agent, or the law
              </li>
              <li>
                <strong>A statement</strong> that the information in the notice is accurate, and under penalty of perjury, 
                that you are authorized to act on behalf of the copyright owner
              </li>
              <li>
                <strong>Your physical or electronic signature</strong>
              </li>
            </ol>
          </section>

          <section className="bg-gray-900 border border-gray-800 rounded-lg p-6">
            <h3 className="text-xl font-bold text-orange-500 mb-3">Send DMCA Notices To:</h3>
            <p>
              <strong>Email:</strong> <a href="mailto:dmca@trapcomix.com" className="text-orange-500 hover:text-orange-600">dmca@trapcomix.com</a><br />
              <strong>Subject Line:</strong> "DMCA Takedown Request"<br />
              <strong>Mailing Address:</strong><br />
              Trap Comix DMCA Agent<br />
              [Your Company Address]<br />
              [City, State ZIP]
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Counter-Notice Procedure</h2>
            <p className="mb-3">
              If you believe that content you posted was removed in error or misidentification, you may file a counter-notice 
              containing the following:
            </p>
            <ol className="list-decimal list-inside space-y-3 ml-4">
              <li><strong>Your physical or electronic signature</strong></li>
              <li><strong>Identification of the material</strong> that has been removed and its prior location</li>
              <li>
                <strong>A statement under penalty of perjury</strong> that you have a good faith belief the material was removed 
                due to mistake or misidentification
              </li>
              <li>
                <strong>Your name, address, and telephone number</strong>, and a statement that you consent to the jurisdiction 
                of the Federal District Court for your judicial district
              </li>
              <li>
                <strong>A statement</strong> that you will accept service of process from the person who provided the original 
                DMCA notice or their agent
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Repeat Infringer Policy</h2>
            <p>
              Trap Comix will terminate the accounts of users who are repeat copyright infringers. We may also, 
              at our discretion, limit access to the Platform for users who have received multiple DMCA notices, 
              whether or not they result in removal of content.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">False Claims</h2>
            <p className="text-yellow-500">
              ⚠️ <strong>Warning:</strong> Under Section 512(f) of the DMCA, anyone who knowingly materially misrepresents 
              that material is infringing or was removed by mistake may be subject to liability. Please do not make false claims.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Processing Time</h2>
            <p>
              We aim to process valid DMCA notices within <strong>72 hours</strong>. Counter-notices are typically processed 
              within <strong>10-14 business days</strong>, as required by law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Additional Information</h2>
            <p className="mb-3">
              Before filing a DMCA notice, please consider:
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Is the use potentially fair use? (commentary, criticism, parody, education)</li>
              <li>Have you tried contacting the user directly to resolve the issue?</li>
              <li>Are you certain the content infringes your copyright?</li>
            </ul>
            <p className="mt-3">
              For more information about the DMCA, visit the U.S. Copyright Office website: 
              <a href="https://www.copyright.gov" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600 ml-1">
                www.copyright.gov
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DMCAPolicy;